const WPpixelProductCard = (productID: number, productName: string, productPrice: string) => {
  if (window?.wph && typeof window?.wph === 'function') {
    window.wph('track', 'ViewContent', {
      content_type: 'Site',
      content_name: 'ViewProduct',
      contents: [{
        id: productID,
        name: productName,
        price: productPrice
      }]
    });
  }
};
export default WPpixelProductCard;